const DEFAULT_CANONICAL_APP_ORIGIN = 'https://platform.quantchecklabs.com';

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

const KNOWN_PRODUCTION_ALIAS_HOSTS = new Set([
  'www.platform.quantchecklabs.com',
  'quantchecklabs.com',
  'www.quantchecklabs.com',
  'react-qcl-website.vercel.app',
  'www.react-qcl-website.vercel.app',
]);

const normalizeOrigin = (value: string): string => {
  try {
    const url = new URL(value);
    return `${url.protocol}//${url.host}`;
  } catch {
    return DEFAULT_CANONICAL_APP_ORIGIN;
  }
};

const getHostnameFromOrigin = (origin: string): string | null => {
  try {
    return new URL(origin).hostname.toLowerCase();
  } catch {
    return null;
  }
};

export const getCanonicalAppOrigin = (): string => {
  const configured = (process.env.REACT_APP_CANONICAL_APP_ORIGIN || '').trim();
  if (!configured) {
    return DEFAULT_CANONICAL_APP_ORIGIN;
  }
  return normalizeOrigin(configured);
};

export const getCanonicalRedirectUrl = (
  locationLike: Pick<Location, 'origin' | 'pathname' | 'search' | 'hash'>
): string | null => {
  const currentHost = getHostnameFromOrigin(locationLike.origin);
  if (!currentHost) return null;
  if (LOCAL_HOSTS.has(currentHost)) return null;

  const canonicalOrigin = getCanonicalAppOrigin();
  const canonicalHost = getHostnameFromOrigin(canonicalOrigin);
  if (!canonicalHost) return null;
  if (currentHost === canonicalHost) return null;

  if (!KNOWN_PRODUCTION_ALIAS_HOSTS.has(currentHost)) {
    return null;
  }

  return `${canonicalOrigin}${locationLike.pathname}${locationLike.search}${locationLike.hash}`;
};
